export const BrandWizardSteps = {
  BASIC_INFO: 'basic-info',
  CONTACT: 'contact'
} as const;

export type BrandWizardStep = typeof BrandWizardSteps[keyof typeof BrandWizardSteps];

export const BRAND_WIZARD_STEP_ORDER: BrandWizardStep[] = [
  BrandWizardSteps.BASIC_INFO,
  BrandWizardSteps.CONTACT
];

export const BRAND_WIZARD_STEP_LABELS: Record<BrandWizardStep, string> = {
  [BrandWizardSteps.BASIC_INFO]: 'Basic Info',
  [BrandWizardSteps.CONTACT]: 'Contact'
};
